import { render, staticRenderFns } from "./EditorNewAssignmentItem.vue?vue&type=template&id=671ed3e2&scoped=true&"
import script from "./EditorNewAssignmentItem.vue?vue&type=script&lang=js&"
export * from "./EditorNewAssignmentItem.vue?vue&type=script&lang=js&"
import style0 from "./EditorNewAssignmentItem.vue?vue&type=style&index=0&id=671ed3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ed3e2",
  null
  
)

export default component.exports